import { render } from "./current_color_logo_horizontal.svg?vue&type=template&id=7ad80bca"
import script from "./current_color_logo_horizontal.svg?vue&type=script&lang=js"
export * from "./current_color_logo_horizontal.svg?vue&type=script&lang=js"

import "./current_color_logo_horizontal.svg?vue&type=style&index=0&id=7ad80bca&lang=css"

import exportComponent from "/codebuild/output/src279/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__